module.exports = __webpack_public_path__ + "img/switchStorage.f5de7f72.svg";